module.exports = __webpack_public_path__ + "media/components/shared/nav_bar_images/error-45f77b34a9e8dacc816cfdac510c10d6.svg";